var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleBetDisableBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "4 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#______src_components_common_betArea_svg_DoubleBetDisableBtn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#______src_components_common_betArea_svg_DoubleBetDisableBtn_svg__b)",
    fillOpacity: 0.85,
    d: "M4 50.5C4 22.886 26.386.5 54 .5s50 22.386 50 50-22.386 50-50 50-50-22.386-50-50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeWidth: 2,
    d: "M5 50.5c0-27.062 21.938-49 49-49s49 21.938 49 49-21.938 49-49 49-49-21.938-49-49Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#565656",
    clipPath: "url(#______src_components_common_betArea_svg_DoubleBetDisableBtn_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.396 44.043a2.34 2.34 0 0 0-3.312 0L38 51.126l-7.083-7.083a2.34 2.34 0 0 0-3.312 0 2.34 2.34 0 0 0 0 3.313l7.083 7.083-7.084 7.104a2.34 2.34 0 0 0 0 3.313 2.35 2.35 0 0 0 1.667.687 2.35 2.35 0 0 0 1.667-.687l7.083-7.084 7.084 7.084a2.35 2.35 0 0 0 1.666.687 2.35 2.35 0 0 0 1.667-.687 2.34 2.34 0 0 0 0-3.313l-7.084-7.083 7.084-7.084a2.34 2.34 0 0 0 0-3.312zm25.333 11.039c1.27-1.146 2.354-2.23 3.208-3.25s1.521-2.167 1.938-3.396c.416-1.208.625-2.666.625-4.312 0-2.334-.542-4.459-1.625-6.313a12.2 12.2 0 0 0-4.438-4.416c-1.854-1.084-4-1.626-6.354-1.626s-4.604.521-6.52 1.584a11.7 11.7 0 0 0-4.543 4.354c-1.104 1.833-1.666 3.98-1.666 6.375v.313h5.333v-.313c0-1.292.292-2.52.917-3.604.625-1.104 1.52-2 2.625-2.667s2.375-1 3.791-1c1.417 0 2.605.334 3.667.959a7.04 7.04 0 0 1 2.563 2.624c.625 1.105.937 2.355.937 3.73a8.3 8.3 0 0 1-.687 3.291c-.459 1.063-1.355 2.209-2.688 3.417l-16.5 14.854-.104.083v4.584h25.313v-5.021H62.375l11.375-10.23z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_components_common_betArea_svg_DoubleBetDisableBtn_svg__b",
    x1: 4,
    x2: 104,
    y1: 0.5,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221E1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "______src_components_common_betArea_svg_DoubleBetDisableBtn_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.917 31.75H79.5v38.563H26.917z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "______src_components_common_betArea_svg_DoubleBetDisableBtn_svg__a",
    width: 108,
    height: 108,
    x: 0,
    y: 0.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6524_250165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6524_250165",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleBetDisableBtn);
export default __webpack_public_path__ + "static/media/DoubleBetDisableBtn.038a699b154e21bddc2f60ebcce19977.svg";
export { ForwardRef as ReactComponent };